export const SHARED_WITH_ME_PAGE_NAME = 'Reports Shared with Me';
export const SHARED_WITH_ME_PAGE_URL = '/gogov/reports/shared-with-me';
export const OWNED_BY_ME_PAGE_NAME = 'Reports Owned by Me';
export const OWNED_BY_ME_PAGE_URL = '/gogov/reports/owned-by-me';

export function getSharedWithMeReportViewUrl(dashboardId: string): string {
  return `/gogov/reports/shared-with-me/view?dashboardId=${encodeURIComponent(
    dashboardId
  )}`;
}
